module.exports = __webpack_public_path__ + "img/WhatsApp Image 2020-03-10 at 4.26.20 PM.485f4894.jpeg";